var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"kt-nav__separator"})
}
var staticRenderFns = []

export { render, staticRenderFns }